import introImage from 'img/aside-poll/aside-poll.jpg';
import introImageDark from 'img/aside-poll/aside-poll-dark.jpg';
import result128 from 'img/aside-poll/tariff-128.jpg';
import result128Dark from 'img/aside-poll/tariff-128-dark.jpg';
import result512 from 'img/aside-poll/tariff-512.jpg';
import result512Dark from 'img/aside-poll/tariff-512-dark.jpg';
import result1000 from 'img/aside-poll/tariff-1000.jpg';
import result1000Dark from 'img/aside-poll/tariff-1000-dark.jpg';
import { IS_AUTO_TEST_HIDE, IS_MOBILE_OR_TABLET_BROWSER, PROMO_TARIFFS } from 'reactApp/appHelpers/configHelpers';
import { abTariffSelection } from 'reactApp/appHelpers/featuresHelpers/features/tariffSelectionPoll';
import { openTariffBuy } from 'reactApp/modules/payment/payment.module';
import { productsController } from 'reactApp/modules/products/products.controller';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { addPromoToShowQueue, promoShown, removePromo } from 'reactApp/modules/promo/promo.module';
import { PromoSelectors } from 'reactApp/modules/promo/promo.selectors';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { SUMMER_PROMO_2026_MODAL_QUERY_PARAM } from 'reactApp/modules/promoNew/items/summerCampaign2026ModalCreator';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserStorageActions } from 'reactApp/modules/user/userStorage';
import { store as reduxStore } from 'reactApp/store';
import { tariffSelectionQuestions } from 'reactApp/ui/AsidePollModal/AsidePollModal.data';
import { openAsidePollModal } from 'reactApp/ui/AsidePollModal/AsidePollModal.helpers';
import type { PollResult } from 'reactApp/ui/AsidePollModal/AsidePollModal.types';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';
import { put } from 'redux-saga/effects';
import { select } from 'typed-redux-saga';

const PROMO_ID = 'tariff-selection-promo';

// НЕ ИСПОЛЬЗОВАТЬ: в большинстве случаев это приведет к багам
// promoShown должен отправляться в onShow, а removePromo – в onClose
// (и в onClick иногда)
function markPromoShown() {
    reduxStore.dispatch(promoShown(EPromoType.tariffSelectionPoll));
    storeHelper.markAsShown(PROMO_ID);
    reduxStore.dispatch(removePromo(EPromoType.tariffSelectionPoll));
}

export function* initTariffSelectionPoll() {
    const storage = yield* select(getCurrentStorage);
    const isPaidUser = yield* select(UserSelectors.isPaidUser);
    const isBizUser = yield* select(UserSelectors.isBizUser);
    // Форс-включение промки для отдельных автотестов.
    const force = yield put(UserStorageActions.get(`force_${PROMO_ID}`)) || false;
    const searchParams = new URLSearchParams(window.location.search);

    if (
        storeHelper.getValue(PROMO_ID) ||
        (IS_AUTO_TEST_HIDE && !force) ||
        // Не показываем поверх акционной модалки летней акции, открытой по прямой ссылке
        searchParams.get(SUMMER_PROMO_2026_MODAL_QUERY_PARAM) ||
        ![EStorageType.home, EStorageType.quotaCleaner].includes(storage) ||
        !abTariffSelection ||
        abTariffSelection === 'a' ||
        (abTariffSelection === 'b' && storage !== EStorageType.quotaCleaner) ||
        (abTariffSelection === 'c' && storage !== EStorageType.home) ||
        isPaidUser ||
        isBizUser ||
        IS_MOBILE_OR_TABLET_BROWSER
    ) {
        return;
    }

    yield put(
        addPromoToShowQueue({
            type: EPromoType.tariffSelectionPoll,
            promoId: PROMO_ID,
            onShow: () => {
                markPromoShown();
                sendPaymentGa({
                    action: 'show',
                    eventCategory: ECategoryGa.balloon,
                    name: 'survey_suitable_tariff',
                });
            },
            onClose: () => {
                markPromoShown();
                sendPaymentGa({
                    action: 'close',
                    eventCategory: ECategoryGa.balloon,
                    name: 'survey_suitable_tariff',
                });
            },
        })
    );
}

const tariffSelectionDisplayResults = (results: PollResult[]) => {
    const isDarkTheme = isDarkThemeModeEnabled();

    let title = 'Тариф 128 ГБ — для вас';
    let image = isDarkTheme ? result128Dark : result128;
    let sizeOffer = 128;
    let productId = PROMO_TARIFFS.suitableTariff128GB;

    if (results[2] === 1) {
        title = 'Тариф 512 ГБ — для вас';
        image = isDarkTheme ? result512Dark : result512;
        sizeOffer = 512;
        productId = PROMO_TARIFFS.suitableTariff512GB;
    } else if (results[2] === 2) {
        title = 'Тариф 1 ТБ — для вас';
        image = isDarkTheme ? result1000Dark : result1000;
        sizeOffer = 1024;
        productId = PROMO_TARIFFS.suitableTariff1TB;
    }

    return {
        image,
        title,
        text: 'Тут всё как нужно: и файлы все поместятся, даже очень большие. И\u00A0реклама отключится',
        buttonText: 'Попробовать за 1 ₽',
        onClick: () => {
            sendPaymentGa({
                action: 'click',
                eventCategory: ECategoryGa.balloon,
                name: 'survey_suitable_tariff_offer_trial',
                size_offer: sizeOffer,
            });
            reduxStore.dispatch(
                openTariffBuy({
                    productId,
                    isMobile: false,
                    paySource: 'survey_suitable_tariff_web_cloud',
                })
            );
        },
        onShow: () => {
            sendPaymentGa({
                action: 'show',
                eventCategory: ECategoryGa.balloon,
                name: 'survey_suitable_tariff_offer_trial',
                size_offer: sizeOffer,
            });
        },
    };
};

export function* showTariffSelectionPoll() {
    const promo = yield* select(PromoSelectors.getPromo(EPromoType.tariffSelectionPoll));

    if (promo) {
        const { onShow, onClose } = promo;
        const isDarkTheme = isDarkThemeModeEnabled();

        if (isDarkTheme) {
            new Image().src = result128Dark;
            new Image().src = result512Dark;
            new Image().src = result1000Dark;
        } else {
            new Image().src = result128;
            new Image().src = result512;
            new Image().src = result1000;
        }

        yield productsController.loadProducts();

        yield openAsidePollModal({
            introTitle: 'Тест на подходящий тариф Mail Space',
            introText: 'Ответьте на несколько вопросов — посоветуем тариф для ваших задач',
            introBtnText: 'Пройти тест',
            introImg: isDarkTheme ? introImageDark : introImage,
            pollQuestions: tariffSelectionQuestions,
            displayResult: tariffSelectionDisplayResults,
            analyticsPrefix: 'survey_suitable_tariff',
            onClose,
            onShow,
        });
    }
}
